import { Enviroment } from "../../../enviroments";
import { Api } from "../axios-config"
import CookieService from "../../autenticacao/CookieService";
import { IListagemFranquia } from "../franquia/FranquiaService";

export interface IDetalhePropostas {
    codigo?: number;
    data_Hora: Date;
    data_Hora_Expira: Date,
    franquias: IListaDadosFranquiasEnvolvidas[],
    codigo_Franquia: number;
    nome_Franquia: string;
    logo_Franquia: string;
    nome_General_Manager: string;
    situacao: number;
    codUsuCriacao: number;
    dtCriacao: Date;
    dados_Proposta: IDadosPropostaTroca[];

}

export interface IListaDadosFranquiasEnvolvidas {
    codigo: number;
    codigo_Proposta: number;
    nome: string;
    logo: string;
    nome_General_Manager: string;
    situacao: number;
}

export interface IDadosPikc {
    codigo: number;
    codigo_Franquia: number;
    tipo: number;
    descricao: string;
    codigo_Franquia_Recebe: number;
    ano: number;
}

export interface IDadosPropostasEnviaRecebe {
    codigo?: number;
    codigo_Franquia_Envia: number;
    nome_Franquia?: string;
    codigo_Franquia_Recebe: number;
    nome_Franquia_Recebe?: string;
    nome_Jogador?: string;
    imagem?: string;
    valores?: string;
    descricao?: string;

    tipo_Ativo: number;
}

export interface IDadosHistoricoPropostas {
    codigo: number;
    descricao: string;
}

export interface IDadosPropostas {
    codigo?: number;
    nome_Franquia_Envia?: string;
    codigo_Franquia_Envia?: number;
    logo_Franquia_Envia?: string;
    nome_Franquia_Recebe?: string;
    codigo_Franquia_Recebe?: number;
    logo_Franquia_Recebe?: string;
    nome_General_Manager_Envia?: string;
    nome_General_Manager_Recebe?: string;
    situacao: number;
    dados_Propostas: IDadosPropostaTroca[];

}

export interface IDadosPropostaTroca {
    codigo?: number;
    tipo_Ativo: number;
    tipo_Multa: number;
    codigo_Proposta?: number;
    codigo_Franquia_Envia: number;
    codigo_Franquia_Recebe: number;
    nome_Franquia_Envia: string;
    logo_Franquia_Envia?: string;
    nome_Franquia_Recebe: string;
    logo_Franquia_Recebe?: string;
    codigo_Jogador?: number;
    nome_Jogador?: string;
    nome_Jogador_Multa?: string;
    quantidade_Anos_Multa?: number;
    codigo_Jogador_Multa?: string;
    nome_Jogador_Dispensa?: string;
    codigo_Multa?: number;
    valor_Multa?: string;
    valor_Multa_Quebrada?: string;
    codigo_Jogador_Dispensa?: number;
    codigo_Pick_Franquia?: number;
    ano_Pick?: string;
    primeira_Pick_Swap?: string;
    segunda_Pick_Swap?: string;
    terceira_Pick_Swap?: string;
    rodada_Pick?: number;
    posicao_Final?: number;
    descricao_Posicao_Final?: string;
    protecao?: boolean;
    codigo_Proposta_Troca_Nova?: number;
    swap?: boolean;
    codigo_Franquia_Swap?: number;
    foto_Jogador?: string;
    imagem?: string;
    valor_Jogador?: string | undefined;
    tempo_Contrato_Jogador?: string | undefined;
    codigo_Temporada_Multa?: number | undefined;
    descricao_Temporada_Multa?: string;
    nome_Franquia_Origem_Pick: string;
    codigo_Pick_Swap?: number;
    inicio_Protecao?: number;
    fim_Protecao?: number;
    codigo_Pick_Novo?: number;
    ano_Pick_Swap?: string;
    rodada_Pick_Swap?: number;
    posicao_Final_Swap?: number;
    descricao_Posicao_Final_Swap?: string;
    nome_Franquia_Origem_Pick_Swap?: string;
    ano_Pick_Protecao?: string;
    rodada_Pick_Protecao?: number;
    posicao_Final_Protecao?: number;
    descricao_Posicao_Final_Protecao?: string;
    nome_Franquia_Origem_Pick_Protecao?: string;


}


export interface IDadosRetornoPropostas {
    dado: IDetalhePropostas[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

type TPropostasComTotalCount = {
    data: IDadosRetornoPropostas;
    totalCount: number;
}


export interface IDadosRetornoPropostasPorCodigo {
    dado: IDetalhePropostas;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosPropostas {
    codigo: number;
    franquias: IListagemFranquia[];
    tipo: string;
    data: Date;
    data_Limite: Date;
}

export interface IDadosRetornoSalvar {
    dado: number;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}

export interface IDadosSavePropostas {
    codigo?: number;
    data_Hora: Date | string;
    codigo_Liga: number;
    codigo_Temporada: number;
    observacao: string;
    codUsuCriacao: number;
    proposta_Troca: IListaDadosSaveProposta[];
}

export interface IListaDadosSaveProposta {
    coodigo?: number
    codigo_Franquia_Envia: number;
    codigo_Franquia_Recebe: number;
    codigo_Jogador?: number;
    nome_Jogador?: string;
    codigo_Multa?: number;
    codigo_Jogador_Dispensa?: number;
    codigo_Pick_Franquia?: number;
    ano_Pick?: number;
    rodada_Pick?: string;
    protecao?: number;
    codigo_Proposta_Troca_Nova?: number;
    swap?: number;
    codigo_Franquia_Swap?: number;
    tipo_Ativo: number;
}

export interface IDadosRetornoAtivosProposta {
    dado: IDadosAtivosPropostas;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}

export interface IDadosAtivosPropostas {
    separar_Multa_Temporada: number;
    jogadores: IDadosJogadores[],
    jogadores_Dispensa: IDadosJogadores[],
    multas_Completo: IDadosMultasCompleto[],
    multas_Temporada: IDadosMultas[],
    picks: IDadosPiclks[]

}

export interface IDadosRetornoAtivosPropostaSwap {
    dado: IDadosPiclks[]
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}

export interface IDadosAtivosPropostaSwap {
    swap: IDadosPiclks[]
}

export interface IDadosJogadores {
    codigo: number;
    nome: string;
    foto: string;
    valor_Contrato: string;
    tempo_Contrato: number;
}

export interface IDadosMultasCompleto {
    codigo: number;
    valor_Multa: string;
    codigo_Temporada: number;
    descricao_Temporada: string;
    codigo_Jogador: number;
    nome_Jogador: string;
    valores_Multa: number[];
    quantidade_Anos_Multa: number;
}


export interface IDadosMultas {
    codigo: number;
    valor_Multa: string;
    codigo_Temporada: number;
    descricao_Temporada: string;
    codigo_Jogador: number;
    nome_Jogador: string;
}

export interface IDadosPiclks {
    codigo: number;
    ano: number;
    rodada: number;
    franquia_Origem: string;
    posicao_Final?: number;
    descricao_Posicao_Final?: string;
    loteria: boolean;
    codigo_Temporada: number;
}

export interface IDadosAceitarProposta {
    codigo: number; //Proposta
    codigo_Franquia: number;
    codigo_Usuario: number;

}

export interface IDadosRejeitarProposta {
    codigo: number; //Proposta
    codigo_Franquia: number;
    codigo_Usuario: number;
}


export interface IDadosReverterProposta {
    codigo: number; //Proposta    
    codigo_Usuario: number;

}

export interface IRetornoPropostaSimplificada {
    dado: IDadosPropostaSimplificada;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}


export interface IDadosPropostaSimplificada {
    franquia1: IDadosFranquiaPropostaSimplificada;
    franquia2: IDadosFranquiaPropostaSimplificada;
}

export interface IDadosFranquiaPropostaSimplificada {
    codigo: number;
    nome: string;
    logo: string;
    caP_Disponivel: string;
    caP_Gasto: string;
    slot_Disponivel: number;
    itens: IDadosAtivosPropostaSimplificada[];
}

export interface IDadosAtivosPropostaSimplificada {
    codigo: number;
    codigo_Tipo_Ativo: number;
    codigo_Jogador: number;
    nome_Jogador: string;
    posicao_1: string;
    posicao_2: string;
    posicao_3: string;
    jogos: number;
    minutos: number;
    peso_Total: number;
    peso_Minutos: number;
    valor_Contrato: string;
    tempo_Contrato: number;
    codigo_Pick: number;
    descricao_Pick: string;
    codigo_Multa: number;
    valor_Multa: number;
    tempo_Multa: number;
    nome_Jogador_Multa: string;
}

const getAllPorCodigoFranquia = async (codigoFranquia: number): Promise<TPropostasComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/proposta/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getPorCodigo = async (codigo: number): Promise<IDadosRetornoPropostasPorCodigo> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/proposta/completo/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getPropostasAtivos = async (codigoFranquia: number): Promise<IDadosRetornoAtivosProposta> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/proposta/ativos/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}


const getPropostasAtivoSwap = async (codigoFranquiaRecebe: number, codigoTemporada: number, rodada: number): Promise<IDadosRetornoAtivosPropostaSwap> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/proposta/ativos/swap/${codigoFranquiaRecebe}/${codigoTemporada}/${rodada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getDadosPropostaSimples = async (codigoFranquia: number, codigoFranquiaRecebe: number): Promise<IRetornoPropostaSimplificada> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/proposta/simplificada/${codigoFranquia}/${codigoFranquiaRecebe}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}



const Create = async (dados: Omit<IDadosSavePropostas, "codigo">): Promise<IDadosRetornoSalvar> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/proposta`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const CreateHistorico = async (dados: Omit<IDadosSavePropostas, "codigo">): Promise<IDadosRetornoSalvar> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/proposta/historico`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


const CreateContraProposta = async (dados: IDadosSavePropostas): Promise<IDadosRetornoSalvar> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.put(`/proposta/contraproposta`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const aceiteProposta = async (dados: IDadosAceitarProposta): Promise<void> => {
    const token = CookieService.get("access_token");
    //dados.codUsuModificacao = user.codUsuario;
    return await Api.put(`/proposta/aceitar`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const rejeitarProposta = async (dados: IDadosRejeitarProposta): Promise<void> => {
    const token = CookieService.get("access_token");
    //const user = CookieService.get("access_user");
    //dados.codUsuModificacao = user.codUsuario;
    return await Api.put(`/proposta/rejeitar`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const deleteById = async (codigo: number, codigoFranquia: number): Promise<void> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    return await Api.delete(`/proposta/${codigo}/${codigoFranquia}/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const getHistoricoPropostasPorCodigoLiga = async (codigoLiga: number): Promise<IDadosRetornoPropostas> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/proposta/historico/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const Simulate = async (dados: Omit<IDadosSavePropostas, "codigo">): Promise<IDadosRetornoSalvar> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/proposta/simular`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const updateReverter = async (dados: IDadosReverterProposta): Promise<void> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");    
    dados.codigo_Usuario = user.codUsuario;
    return await Api.put(`/proposta/reverter`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

export const PropostaService = {
    getPorCodigo,
    getPropostasAtivos,
    getAllPorCodigoFranquia,
    Create,
    aceiteProposta,
    rejeitarProposta,
    deleteById,
    getHistoricoPropostasPorCodigoLiga,
    CreateContraProposta,
    getPropostasAtivoSwap,
    Simulate,
    getDadosPropostaSimples,
    CreateHistorico,
    updateReverter
}